<template>
  <div>
    <client-average-payment-duration-report-list></client-average-payment-duration-report-list>
  </div>
</template>

<script>
export default {
}
</script>
